@if (visible) {
  <span
    class="scribe-suggestion-badge"
    [attr.aria-label]="variant === 'compact' ? 'Scribe Suggestion Used' : null"
    [attr.role]="variant === 'compact' ? 'img' : null"
    matTooltip="Scribe Suggestion Used"
    [matTooltipDisabled]="variant !== 'compact'"
    matTooltipPosition="above"
  >
    <rx-icon
      class="scribe-suggestion-badge__icon"
      name="scribe-suggestion-used"
      [size]="11"
      aria-hidden="true"
    ></rx-icon>
    @if (variant === 'full') {
      <span class="scribe-suggestion-badge__label" title="Scribe Suggestion Used"> Scribe Suggestion Used </span>
    }
  </span>
}
